import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-responsive-modal';
import styled from 'styled-components';
import modalCss from 'react-responsive-modal/styles.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { compose } from 'recompose';
import { toast } from 'react-toastify';
import CloseIcon from '../../../../travelerProfile/components/icons/CloseIcon';
import ConfirmDeleteIcon from '../../../../travelerProfile/components/icons/ConfirmDeleteIcon';
import TextInput from '../../../../../styledComponents/styles/TextInput.styled';
import { deleteSubmissionTag } from '../../../../../actions/formsActions';
import toastMessageStyles from '../../../../../sites/viaGlobal/components/toastMessage/toastMessage.scss';
import { CircularProgress } from '@material-ui/core';

const enhance = compose(withStyles(modalCss, toastMessageStyles));

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 25px 25px;
  border-bottom: 5px solid var(--theme_color_accent);
`;

const Container = styled.div`
  padding: 30px 70px;
  display: flex;
  flex-direction: row;
  gap: 14px;
`;

const Heading = styled.h2`
  color: #373737;
  text-align: center;

  /* Headline 5 */
  font-family: Nunito;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 30px */
`;

const Footer = styled.div`
  border-radius: 0px 0px 10px 10px;
  background: #ebebeb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
  //   gap: 55px;
`;

const CancelBtn = styled.button`
  color: #373737;
  /* Button Primary */
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.96px;
  border: none;

  padding: 0;
`;

const PrimaryBtn = styled.button`
  border-radius: 5px;
  background: var(--theme_color_accent);
  color: var(--theme_color_accent_font);
  text-align: center;
  /* Button Primary */
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.96px;
  border: 1px #d74b73;
  padding: 16px 28px;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.7;
  }
`;

const CloseButton = styled.button`
  outline: none;
  border: none;
  padding: 0;
  background: none;
`;

const ImageContainer = styled.div`
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Description = styled.div`
  color: #373737;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.08px;
`;

const DescriptionBold = styled(Description)`
  font-weight: 700;
`;

const TextInputParentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TextInputContainer = styled.div`
  width: 300px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 50px;
  justify-content: center;
  margin-top: 20px;
`;

function DeleteSubmissionTagModal({ open, onClose, tagId, submissionType, onSuccess,tagName }) {
  const dispatch = useDispatch();
  const [deleteInput, setDeleteInput] = useState('');
  const { loading } = useSelector(state => state.forms.deleteTag);

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(
      deleteSubmissionTag(tagId,tagName,submissionType, (status, message) => {
        if (status) {
          toast(message, {
            type: 'success',
            className: toastMessageStyles['successContainer'],
            toastClassName: toastMessageStyles['wrapper'],
            bodyClassName: toastMessageStyles['successBody'],
            progressClassName: toastMessageStyles['progress-bar'],
            position: 'bottom-right'
          });
          onSuccess(tagId);
          onClose();
        } else {
          toast(message, {
            type: 'error',
            className: toastMessageStyles['failureContainer'],
            toastClassName: toastMessageStyles['wrapper'],
            bodyClassName: toastMessageStyles['failureBody'],
            progressClassName: toastMessageStyles['progress-bar'],
            position: 'bottom-right'
          });
        }
      }),
    );
  };

  return (
    <Modal
      blockScroll={false}
      open={open}
      onClose={onClose}
      center
      closeOnEsc
      closeOnOverlayClick
      showCloseIcon={false}
      styles={{
        modal: {
          padding: '0px',
          borderRadius: '5px',
          width: '550px',
        },
      }}
    >
      <Header>
        <Heading>Confirm Deletion</Heading>

        <CloseButton onClick={onClose}>
          <CloseIcon fillColor={`#9FABAE`} />
        </CloseButton>
      </Header>

      <Container>
        <ImageContainer>
          <ConfirmDeleteIcon />
        </ImageContainer>

        <TextContainer>
          <Description>
            {submissionType==="User" ? 
            "Deleting a tag will remove the tag record from selected traveler(s)." : 
            `Deleting a tag will remove the tag record from all applications and forms associated.`
            }
            
          </Description>
          <DescriptionBold>Deleted tags cannot be recovered.</DescriptionBold>
        </TextContainer>
      </Container>

      <Footer>
        <form onSubmit={handleSubmit}>
          <TextInputParentContainer>
            <TextInputContainer>
              <TextInput
                id={'delete'}
                name={'delete'}
                label={'Type DELETE to delete this tag'}
                placeholder={'Type DELETE to confirm'}
                errorMsg={''}
                value={deleteInput}
                onChange={e => {
                  setDeleteInput(e.target.value);
                }}
              />
            </TextInputContainer>
          </TextInputParentContainer>

          <ButtonContainer>
            <CancelBtn onClick={onClose} type="button">
              Cancel
            </CancelBtn>
            <PrimaryBtn disabled={deleteInput !== 'DELETE' || loading} type="submit">
              Delete {loading && <CircularProgress size={15} color="inherit" />}
            </PrimaryBtn>
          </ButtonContainer>
        </form>
      </Footer>
    </Modal>
  );
}

export default enhance(DeleteSubmissionTagModal);
